module.exports = __webpack_public_path__ + "static/media/Approval_Letter.c485b932.pdf";